import Axios from '../Axios';

const country = {
	create(data) {
		return Axios.post('/countries', data);
	},
	read(limit = 10, page = 1, search) {
		return Axios.get(
			'/countries?limit=' + limit + '&page=' + page + search
		);
	},
	readOne(id) {
		return Axios.get('/countries/' + id);
	},
	update(id, data) {
		return Axios.put('/countries/' + id, data);
	},
	delete(id) {
		return Axios.delete('/countries/' + id);
	},
};

export default country;
